import React from 'react';
import cx from 'classnames';
import {Flex, Text} from '@priority-software/priority-style-react';
import styles from '../../styles/ToDoListConent.module.scss';
import {DOC_NUM, DOC_TYPE, CUST_NAME, SUPP_NAME, monitor} from '../../consts';
import {getFieldValue, MandatoryColIds, getIsSingleWord} from '../../utils';
import {Tooltip} from '../../../../components/Common/Tooltip/index';
import {getTopDialogZindex} from '../../../../_shared/GWTBridge/invoke/priModalDlg';
import {Record} from '../../../../stores/Form/Record';
import {doZoom} from '../../actions';
import {sendMonitor} from '../../../../utils/monitoring';

export const ToDoItemBasicInfo = ({
    record,
    mandatoryColIds,
    tooltipPosition
}: {
    record: Record;
    mandatoryColIds: MandatoryColIds;
    tooltipPosition;
}) => {
    const docNumVal = getFieldValue(record, mandatoryColIds[DOC_NUM])?.toString();
    const custNameVal = getFieldValue(record, mandatoryColIds[CUST_NAME])?.toString();
    const suppNameVal = getFieldValue(record, mandatoryColIds[SUPP_NAME])?.toString();
    const custOrVend = custNameVal ? custNameVal : suppNameVal ? suppNameVal : null;
    const docTypeVal = getFieldValue(record, mandatoryColIds[DOC_TYPE])?.toString();
    const dualValue = custOrVend && docTypeVal;

    const onZoom = async () => {
        (window as any).hide_home_page?.();
        doZoom({record, mandatoryColIds, docNumVal});
        sendMonitor(monitor.TODOLIST_DrillDown);
    };

    return (
        <div className={styles.basicInfo}>
            <Flex direction="column" alignItems="flex-start">
                <Text
                    skin="paragraph-2"
                    textColor="primary-500"
                    componentClasses={styles.docNum}
                    onClick={onZoom}
                >
                    {docNumVal}
                </Text>
                <Flex justifyContent="flex-start" componentClasses={styles.moreDetails}>
                    {docTypeVal && (
                        <Tooltip
                            tooltip={docTypeVal}
                            position={tooltipPosition}
                            wrapperClassname={cx(styles.ellipsis, {
                                [styles.docTypeVal]: dualValue
                            })}
                            zIndex={getTopDialogZindex()}
                        >
                            <Text
                                skin="breadcrumb"
                                textColor="secondary-500"
                                componentClasses={styles.singleWord}
                            >
                                {docTypeVal}
                            </Text>
                        </Tooltip>
                    )}
                    {dualValue && <div className={styles.separator} />}
                    {custOrVend && (
                        <Tooltip
                            tooltip={custOrVend}
                            position={tooltipPosition}
                            wrapperClassname={styles.ellipsis}
                            zIndex={getTopDialogZindex()}
                        >
                            <Text
                                skin="breadcrumb"
                                textColor="secondary-400"
                                componentClasses={cx({
                                    [styles.ellipsis]: dualValue,
                                    [styles.singleWord]: getIsSingleWord(custOrVend)
                                })}
                            >
                                {custOrVend}
                            </Text>
                        </Tooltip>
                    )}
                </Flex>
            </Flex>
        </div>
    );
};
